import http from "./requestBase";
import {
  addFiletoDB,
  clearFileStore,
  getFilefromDB_byID,
  storeHas,
  FILES_STORE_NAME,
  DB_NAME,
} from "./IndexDB";

class UploadFilesService {
  constructor() {
    this.DB_NAME = DB_NAME;
  }
  /**
   *
   * @param {File} file The file you want to Upload
   * @param {Function} progresscallback - optional callback for Progress event
   * @returns {Promise<R>} - returns the response in a Promise
   */
  upload(file, progresscallback = false) {
    let formData = new FormData();
    let onUploadProgress = progresscallback;
    if (!progresscallback) {
      onUploadProgress = (r) => {};
    }
    formData.append("file", file);

    return http.post("api/Upload", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress,
    });
  }
  /**
   *
   * @param  {Array<SurveyInstanceAnswerFile>}files JSON of files like saved for SurveyInstanceAnswer
   * @returns
   */
  delete(files) {
    return http.post("api/Download/Delete", JSON.stringify(files));
  }

  /**
   *
   * @param {String} id guid of the file
   * @param {boolean} offline true if we want to acces the cache
   * @returns {Promise<File> | Promise<import("axios").AxiosResponse<File>>}
   */
  getFilesbyId(id, offline = false) {
    if (offline) {
      return getFilefromDB_byID(id);
    }
    return http.get(`/api/Download/${id}`, {
      responseType: "blob",
    });
  }
  async clearOfflineFiles() {
    clearFileStore();
  }
  isFileChached(key) {
    return storeHas(FILES_STORE_NAME, key);
  }

  async offlineUpload(file, id) {
    let result = {
      data: [{ DownloadId: [...(await addFiletoDB(file, id))] }],
    };
    return result;
  }
}

export default new UploadFilesService();



// WEBPACK FOOTER //
// ./src/services/UploadService.js